import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { message } from "antd";
import { lib } from "../index";
import "./send-sms-code.less";

/**
 * 发送验证码
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{onSendSuccess?: ()=>{}, size?: string,  mobile: string,  onSendFail?: (error)=>{},  type: string}> & React.RefAttributes<{checkSmsCode:({code,onSuccess,onFail})=>{}}>>}
 */
export const SendSmsCode = forwardRef(
    ({ mobile, type, size = "large", onSendSuccess = () => {}, onSendFail = error => {} }, ref) => {
        let [time, setTime] = useState(0);
        let [now, setNow] = useState(new Date().getTime());
        let leftTime = parseInt((time - now + 60 * 1000) / 1000);
        useEffect(() => {
            const timer = setInterval(() => {
                setNow(new Date().getTime());
            }, 1000);
            return () => clearInterval(timer);
        }, []);

        useImperativeHandle(ref, () => ({
            checkSmsCode: checkSmsCode,
            resetTime: resetTime,
        }));

        function checkSmsCode({ code, onSuccess, onFail }) {
            if (!mobile) {
                message.error("该账号未绑定真实手机号，请绑定后再进行操作");
                return;
            }
            const { host } = window.location;
            const data = {
                mobile,
                type,
                code,
                domain: host,
            };
            lib.request({
                url: "/ucenter-account/sms/check",
                data: data,
                needMask: true,
                success: data => {
                    resetTime();
                    onSuccess && onSuccess();
                },
                fail: error => {
                    onFail && onFail();
                },
            });
        }
        function resetTime() {
            setTime(0);
        }
        return (
            <div
                className={`send-sms-code ${size} ${leftTime > 0 && "count-down"}`}
                onClick={() => {
                    if (leftTime < 0) {
                        if (!mobile) {
                            message.error("该账号未绑定真实手机号，请绑定后再进行操作");
                            return;
                        }
                        const { host } = window.location;
                        let formData = {
                            mobile,
                            type,
                            domain: host,
                        };
                        lib.request({
                            url: "/ucenter-account/sms/send",
                            data: formData,
                            needMask: true,
                            success: data => {
                                setTime(new Date().getTime());
                                onSendSuccess();
                                message.success("手机验证码发送成功");
                            },
                            fail: error => {
                                onSendFail(error);
                            },
                        });
                    }
                }}>
                {leftTime > 0 ? leftTime : "获取验证码"}
            </div>
        );
    },
);
